import HandWritingController from './hand-writing';

/**
 * 数学入力用のコントローラ。
 * HandWritingControllerから派生する。
 * 
 * [依存関係]
 * HandWritingController
 * 
 * @param {*} $scope 
 */
export default function ($scope) {
  HandWritingController($scope);

  $scope.superOnExported = $scope.onExported;
  /**
   * 認識結果受信後の処理: 既存の処理に合わせ、selectAnswers() を呼ぶ
   * @param {*} e 
   */
  $scope.onExported = function(e) {
    const editor = e.target.editor;

    if (editor && e.detail.exports) {
      const result = e.detail.exports['application/x-latex'];
      if (result) {
        // 手書き描画を消去する
        $scope.link.clearCanvas();
        // 認識結果値をそのまま渡す
        mathLib.selectAnswers(e.target.id, result);
      }
    }

    $scope.superOnExported(e);
  }

  /**
   * API発行直前の処理
   */
  $scope.beforeExportApi = () => {
    // API 発行を登録（既存処理連携）
    setDoingRecognition(currentComponentId, 3000)
  }
}